<script setup lang="ts"></script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M22 19.5814H2V17.6279H3V10.8214C3 5.94945 7.02944 2 12 2C16.9706 2 21 5.94945 21 10.8214V17.6279H22V19.5814ZM9.5 20.5581H14.5C14.5 21.9067 13.3807 23 12 23C10.6193 23 9.5 21.9067 9.5 20.5581Z"
            fill="#FF6971"
        />
    </svg>
</template>
